const s = {
  NEED_PASSWORD: 1,
  INCORRECT_PASSWORD: 2
};
export {
  s as default
};
//# sourceMappingURL=PasswordResponses.es.js.map
